// Models

export class UserInfoViewModel {
  constructor(
    public email: string,
    public emailVerified: boolean
  ) {}
}
